import { combineReducers } from 'redux';

const byId = (state = {}, action) => {
  const item = action.slug ? state[action.slug] : undefined;
  switch (action.type) {
    case 'FETCH_MEDIA_SUCCESS':
    case 'FETCH_LISTS_SUCCESS':
      return {
        ...state,
        ...action.response.entities.series,
        ...action.response.entities.videos,
        ...action.response.entities.media,
      };
    case 'START_GAME':
      return {
        ...state,
        [action.slug]: {
          ...item,
          isStarted: true,
          isOver: false,
          displayGameOverAd: false,
        },
      };
    case 'END_GAME':
      return {
        ...state,
        [action.slug]: {
          ...item,
          isOver: true,
          playerWon: action.gameData.playerWon,
          showEndCard: action.gameData.showEndCard,
        },
      };
    case 'REPLAY_GAME':
      return {
        ...state,
        [action.slug]: {
          ...item,
          isOver: false,
          restartGame: true,
          playerWon: undefined,
        },
      };
    case 'GAME_RESTARTED':
      return {
        ...state,
        [action.slug]: {
          ...item,
          isOver: false,
          restartGame: false,
        },
      };
    case 'SHOW_GAME_OVER_AD':
      return {
        ...state,
        [action.slug]: {
          ...item,
          displayGameOverAd: true,
        },
      };
    case 'CLOSE_GAME_OVER_AD':
      return {
        ...state,
        [action.slug]: {
          ...item,
          displayGameOverAd: false,
        },
      };
    default:
      return state;
  }
};

const bookBySlug = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_BOOK_DATA_SUCCESS':
      return {
        ...state,
        [action.slug]: action.response,
      };
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_MEDIA_REQUEST':
      return true;
    case 'FETCH_MEDIA_SUCCESS':
    case 'FETCH_MEDIA_FAILURE':
      return false;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_MEDIA_FAILURE':
      return action.error;
    case 'FETCH_MEDIA_SUCCESS':
    case 'FETCH_MEDIA_REQUEST':
    case 'FETCH_LISTS_REQUEST':
      return null;
    default:
      return state;
  }
};

const media = combineReducers({
  byId,
  isFetching,
  bookBySlug,
  error,
});
export default media;

export const getMediaItem = (state, slug) => state.byId[slug];
export const getMediaSeries = (state, mediaId) => {
  const mediaItem = state.byId[mediaId];
  return mediaItem ? state.byId[mediaItem.series] : null;
};
export const getBookData = (state, slug) => state.bookBySlug[slug];
export const getFirstVideoInSeries = (state, seriesId) => {
  const series = state.byId[seriesId];
  if (!series) return null;
  const firstVideo = state.byId[series.videos[0]];
  return firstVideo ? firstVideo : null;
};
export const getIsFetching = state => state.isFetching;
